import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

let isInitialized = false;

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isInitialized) {
      ReactGA.initialize("G-7DB1XN0GKP"); // 一度だけ初期化
      isInitialized = true;
    }

    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
};

export default usePageTracking;
